import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CluPermissionService } from "./clu-permission.service";
import { CluPermissionDirective } from "./clu-permission.directive";
import { CluPermissionGuard } from "./clu-permission.guard";
import { CluPermissionUnauthorizedComponent } from "./clu-permission-unauthorized/clu-permission-unauthorized.component";
import { RouterModule, Routes } from "@angular/router";
// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { MaterialModule } from "src/app/material.module";

const cluPermissionRoutes: Routes = [
    {
        path: 'unauthorized',
        component: CluPermissionUnauthorizedComponent,
    },
];

@NgModule({
    declarations: [
        CluPermissionUnauthorizedComponent,
        CluPermissionDirective
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(cluPermissionRoutes),
        TablerIconsModule.pick(TablerIcons),
        MaterialModule,
    ],
    exports: [
        CluPermissionDirective
    ],
    providers: [
        CluPermissionService,
        CluPermissionGuard 
    ]
})
export class CluPermissionModule {}